const sims = {
    state: {
        new: []
    },
    mutations: {
        PUSH_NEW_SIMS(state) {
            state.new.push(0)
        },
        SPLICE_NEW_SIMS(state, index) {
            state.new.splice(index, 1)
        },
        RESET_NEW_SIMS(state) {
            state.new = []
        },
        SET_NEW_SIMS_NAME(state, payload) {
            state.new[payload.index].name = payload.value
        },
        SET_NEW_SIMS_COST(state, payload) {
            state.new[payload.index].cost = payload.value
        },
        SET_NEW_SIMS(state, payload) {
            state.new = payload
        }
    },
    getters: {
        getNewSims: state => state.new,
        getNewSimsValue(state) {
            if (!state.new[0]) {
                return 0
            }

            return state.new.map((el) => {
                if (el.cost) {
                    return el.cost
                }

                return 0
            }).reduce((accumulator, currentValue) => parseFloat(accumulator) + parseFloat(currentValue))
        }
    }
}

export default sims